import Vue from 'vue'
import VueRouter from 'vue-router'
import App from '../App.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/instant-quote',
    component: App,
    name: 'App',
    props: true
  },
  {
    path: '/',
    component: App
  },
  
]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router
